import React from "react";
import { useParams } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ListingsBrowser from "../components/ListingsBrowser";
import Seo from "../components/Seo";
import CategoryIcon from "../components/CategoryIcon";
import { categoryById } from "../lib/data";

export default function Listings() {
  const { category } = useParams();
  const cat = category ? categoryById(category) : null;
  const title = cat ? `${cat.label} — The Pataudi` : "All Listings — The Pataudi";
  const desc = cat
    ? `Browse ${cat.label.toLowerCase()} listings in Gurugram, Pataudi and nearby areas on The Pataudi.`
    : "Browse all property, vehicle and service listings in Gurugram, Pataudi and nearby areas.";

  return (
    <div className="min-h-screen flex flex-col">
      <Seo title={title} description={desc} />
      <Header />
      <main className="flex-1">
        <div className="bg-primary text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
            <h1
              className="font-display font-bold text-3xl md:text-4xl flex items-center gap-2.5"
              data-testid="listings-page-title"
            >
              {cat ? (
                <CategoryIcon name={cat.icon} className="h-7 w-7 md:h-8 md:w-8 shrink-0" />
              ) : (
                <LayoutGrid className="h-7 w-7 md:h-8 md:w-8 shrink-0" />
              )}
              <span>{cat ? cat.label : "All Listings"}</span>
            </h1>
            <p className="text-white/70 text-sm mt-1">{cat ? `Find the best ${cat.label.toLowerCase()} near you` : "Explore everything listed on The Pataudi"}</p>
          </div>
        </div>
        <ListingsBrowser key={category || "all"} lockedCategory={category || ""} />
      </main>
      <Footer />
    </div>
  );
}
